export default function () {
  return {
    phone: this.phone,
    phone_country: this.phone_country,
    password: this.password,
  };
}
